import { useContext } from 'react'

import { Context, SettingsFormContext } from '../contexts/SettingsFormContext'

export default function useSettingsFormContext(): Context {
  const contextValue = useContext(SettingsFormContext)

  if (contextValue === null) {
    throw new Error('SettingsFormContext not configured.')
  }

  return contextValue
}
